// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"a08fb2f1","106":"fb7f6b93","176":"a5d1a514","399":"fa5b1d41","443":"5586e4f7","453":"d1dd8043","596":"2f5420b3","965":"a03a3746"}[chunkId] + ".chunk.js";
};